// extracted by mini-css-extract-plugin
export var chevronIcon = "_3x-2";
export var teamName = "_3x-1";
export var teamSwitcherButton = "_3x-0";